import React from 'react';
import { X } from 'lucide-react';

export const StageHolidays = function({ planData, updateData }) {
        var HOLIDAY_LIST = [
          { key: 'thanksgiving', name: 'Thanksgiving' },
          { key: 'christmas_eve', name: 'Christmas Eve' },
          { key: 'christmas_day', name: 'Christmas Day' },
          { key: 'new_years', name: "New Year's" },
          { key: 'easter', name: 'Easter / Spring Holiday' },
          { key: 'st_patricks_day', name: "St. Patrick's Day" },
          { key: 'july4th', name: 'July 4th' },
          { key: 'labor_day', name: 'Labor Day' },
          { key: 'memorial_day', name: 'Memorial Day' },
          { key: 'spring_break', name: 'Spring Break' },
          { key: 'fall_break', name: 'Fall Break' },
        ];
        var FIXED_HOLIDAYS = [
          { key: 'mothers_day', name: "Mother's Day", always: 'mother' },
          { key: 'fathers_day', name: "Father's Day", always: 'father' },
        ];
        var setHoliday = function(key, val) {
          var h = JSON.parse(JSON.stringify(planData.holidays));
          h[key] = val;
          updateData('holidays', h);
        };
        var removeHoliday = function(key) {
          var h = JSON.parse(JSON.stringify(planData.holidays));
          delete h[key];
          updateData('holidays', h);
        };
        var HOLIDAY_OPTIONS = [
          { value: 'plaintiff-odd_defendant-even', label: 'Plaintiff Odd Year / Defendant Even Year', color: '#3B82F6' },
          { value: 'plaintiff-even_defendant-odd', label: 'Plaintiff Even Year / Defendant Odd Year', color: '#EC4899' },
          { value: 'always-plaintiff', label: 'Always Plaintiff', color: '#3B82F6' },
          { value: 'always-defendant', label: 'Always Defendant', color: '#EC4899' },
        ];
        var getHolidayValue = function(hData) {
          if (!hData) return 'plaintiff-odd_defendant-even';
          if (hData === 'always-plaintiff' || hData === 'always-defendant' || hData === 'plaintiff-odd_defendant-even' || hData === 'plaintiff-even_defendant-odd') return hData;
          if (hData.even === 'plaintiff' && hData.odd === 'defendant') return 'plaintiff-even_defendant-odd';
          if (hData.even === 'defendant' && hData.odd === 'plaintiff') return 'plaintiff-odd_defendant-even';
          return 'plaintiff-odd_defendant-even';
        };
        var getOptionColor = function(val) {
          var opt = HOLIDAY_OPTIONS.find(function(o) { return o.value === val; });
          return opt ? opt.color : '#3B82F6';
        };
  return (

          <div className="space-y-6">
            <p className="text-xs text-white/50">Assign each holiday to a parent. Select the rotation or fixed assignment from the dropdown.</p>
            <div className="border border-white/10 rounded-xl overflow-hidden">
              <div className="grid grid-cols-[1fr,1fr,auto] bg-white/5 p-2 text-xs text-white/40 font-medium">
                <span>Holiday</span><span>Assignment</span><span></span>
              </div>
              {HOLIDAY_LIST.filter(function(h) { return planData.holidays[h.key] !== undefined; }).map(function(h) {
                var val = getHolidayValue(planData.holidays[h.key]);
                var clr = getOptionColor(val);
                return (
                  <div key={h.key} className="grid grid-cols-[1fr,1fr,auto] items-center p-2 border-t border-white/[0.04]" data-testid={'holiday-' + h.key}>
                    <span className="text-sm text-white/70">{h.name}</span>
                    <select value={val}
                      onChange={function(e) { setHoliday(h.key, e.target.value); }}
                      style={{ borderColor: clr + '40', color: clr }}
                      className="bg-white border rounded-lg px-3 py-1.5 text-xs font-medium cursor-pointer focus:outline-none"
                      data-testid={'holiday-select-' + h.key}>
                      {HOLIDAY_OPTIONS.map(function(opt) {
                        return <option key={opt.value} value={opt.value} style={{ color: opt.color }}>{opt.label}</option>;
                      })}
                    </select>
                    <button onClick={function() { removeHoliday(h.key); }}
                      className="p-1 text-white/20 hover:text-[#EF4444] transition-colors ml-2"
                      data-testid={'remove-holiday-' + h.key}>
                      <X className="w-3.5 h-3.5" />
                    </button>
                  </div>
                );
              })}
              {FIXED_HOLIDAYS.map(function(h) {
                return (
                  <div key={h.key} className="grid grid-cols-[1fr,1fr] items-center p-2 border-t border-white/[0.04] bg-white/[0.02]">
                    <span className="text-sm text-white/70">{h.name}</span>
                    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-[#2D2560]/10 text-[#2D2560] text-center">Always with {h.always}</span>
                  </div>
                );
              })}
              {/* Custom Holidays */}
              {planData.customHolidays.map(function(ch, ci) {
                var cval = getHolidayValue(ch.assignment || 'plaintiff-odd_defendant-even');
                var cclr = getOptionColor(cval);
                return (
                  <div key={'custom-' + ci} className="grid grid-cols-[1fr,1fr] items-center p-2 border-t border-white/[0.04] bg-[#2D2560]/[0.03]" data-testid={'custom-holiday-' + ci}>
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-white/70">{ch.name}</span>
                      <button onClick={function() {
                        var arr = planData.customHolidays.slice();
                        arr.splice(ci, 1);
                        updateData('customHolidays', arr);
                      }} className="text-[#EF4444]/50 hover:text-[#EF4444] transition-colors" data-testid={'remove-custom-holiday-' + ci}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6L6 18"/><path d="M6 6l12 12"/></svg>
                      </button>
                    </div>
                    <select value={cval}
                      onChange={function(e) {
                        var arr = JSON.parse(JSON.stringify(planData.customHolidays));
                        arr[ci].assignment = e.target.value;
                        updateData('customHolidays', arr);
                      }}
                      style={{ borderColor: cclr + '40', color: cclr }}
                      className="bg-white border rounded-lg px-3 py-1.5 text-xs font-medium cursor-pointer focus:outline-none"
                      data-testid={'custom-holiday-select-' + ci}>
                      {HOLIDAY_OPTIONS.map(function(opt) {
                        return <option key={opt.value} value={opt.value} style={{ color: opt.color }}>{opt.label}</option>;
                      })}
                    </select>
                  </div>
                );
              })}
            </div>

            {/* Add Custom Holiday */}
            <div className="card-surface p-4">
              <label className="block text-sm font-medium mb-2">Add Custom Holiday or Observance</label>
              <div className="flex gap-2">
                <input type="text" id="custom-holiday-input"
                  className="flex-1 bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2 text-sm"
                  placeholder="e.g., Eid, Diwali, Hanukkah, Cultural holiday..."
                  data-testid="custom-holiday-input"
                  onKeyDown={function(e) {
                    if (e.key === 'Enter') {
                      var v = e.target.value.trim();
                      if (v) {
                        updateData('customHolidays', planData.customHolidays.concat([{ name: v, even: 'plaintiff', odd: 'defendant' }]));
                        e.target.value = '';
                      }
                    }
                  }} />
                <button onClick={function() {
                  var el = document.getElementById('custom-holiday-input');
                  var v = el ? el.value.trim() : '';
                  if (v) {
                    updateData('customHolidays', planData.customHolidays.concat([{ name: v, even: 'plaintiff', odd: 'defendant' }]));
                    if (el) el.value = '';
                  }
                }}
                  className="px-4 py-2 rounded-lg bg-[#2D2560]/20 text-[#2D2560] text-sm font-medium hover:bg-[#2D2560]/30 transition-colors"
                  data-testid="add-custom-holiday-btn">
                  Add Holiday
                </button>
              </div>
              <p className="text-xs text-white/30 mt-1">Add religious observances, cultural celebrations, or any other important dates not listed above</p>
            </div>

            {/* School Events Section */}
            <div className="card-surface p-5 space-y-5">
              <div>
                <h3 className="text-sm font-semibold mb-1">School Event Attendance</h3>
                <p className="text-xs text-white/40 mb-3">How should parents handle school events where attendance is limited (e.g., parent-teacher conferences, performances with limited seating)?</p>
                <div className="space-y-2">
                  {[
                    { id: 'alternate', label: 'Alternate Events', desc: 'Parents take turns attending when only one parent can attend' },
                    { id: 'plaintiff-primary', label: 'Plaintiff Attends Primarily', desc: 'Plaintiff attends limited events; defendant attends when plaintiff cannot' },
                    { id: 'defendant-primary', label: 'Defendant Attends Primarily', desc: 'Defendant attends limited events; plaintiff attends when defendant cannot' },
                    { id: 'custodial-parent', label: 'Custodial Parent on That Day', desc: 'The parent who has custody that day attends the event' },
                  ].map(function(opt) {
                    return (
                      <button key={opt.id} onClick={function() { updateData('schoolEventAttendance', opt.id); }}
                        className={'w-full p-3 rounded-lg border text-left transition-all ' +
                          (planData.schoolEventAttendance === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                        data-testid={'school-event-' + opt.id}>
                        <p className="font-medium text-sm">{opt.label}</p>
                        <p className="text-xs text-white/50">{opt.desc}</p>
                      </button>
                    );
                  })}
                </div>

                {planData.schoolEventAttendance === 'alternate' && (
                  <div className="p-4 bg-[#2D2560]/5 border border-[#2D2560]/20 rounded-xl space-y-2 mt-3" data-testid="first-event-attendee">
                    <label className="block text-sm font-medium">Who will attend the first school event of the year?</label>
                    <div className="grid grid-cols-2 gap-2">
                      <button onClick={function() { updateData('schoolEventFirstAttendee', 'plaintiff'); }}
                        className={'p-2.5 rounded-lg border text-sm font-medium text-center transition-all ' + (planData.schoolEventFirstAttendee === 'plaintiff' ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                        data-testid="first-event-plaintiff">Plaintiff</button>
                      <button onClick={function() { updateData('schoolEventFirstAttendee', 'defendant'); }}
                        className={'p-2.5 rounded-lg border text-sm font-medium text-center transition-all ' + (planData.schoolEventFirstAttendee === 'defendant' ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                        data-testid="first-event-defendant">Defendant</button>
                    </div>
                  </div>
                )}
              </div>

              <div>
                <h3 className="text-sm font-semibold mb-1">Public School Events</h3>
                <p className="text-xs text-white/40 mb-3">For events open to the public (open houses, school plays, sporting events, graduations), how should attendance be handled?</p>
                <div className="space-y-2">
                  {[
                    { id: 'both-attend', label: 'Both Parents May Attend', desc: 'Both parents are welcome to attend public events independently' },
                    { id: 'both-with-distance', label: 'Both Attend with Distance', desc: 'Both may attend but agree to maintain physical distance and avoid direct interaction' },
                    { id: 'protective-order', label: 'Protective Order Restrictions Apply', desc: 'Attendance follows the terms of the existing protective order — one parent may need to coordinate timing or seating with school staff' },
                    { id: 'alternate-public', label: 'Alternate Public Events', desc: 'Parents alternate attendance at public events to avoid conflict' },
                  ].map(function(opt) {
                    return (
                      <button key={opt.id} onClick={function() { updateData('schoolEventPublicPolicy', opt.id); }}
                        className={'w-full p-3 rounded-lg border text-left transition-all ' +
                          (planData.schoolEventPublicPolicy === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                        data-testid={'public-event-' + opt.id}>
                        <p className="font-medium text-sm">{opt.label}</p>
                        <p className="text-xs text-white/50">{opt.desc}</p>
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="bg-white/[0.03] border border-white/[0.08] rounded-lg p-4">
                <p className="text-xs text-white/60 leading-relaxed">
                  <span className="font-semibold text-[#2D2560]">Disagreement Policy:</span> In times of disagreement regarding school event attendance, school policy shall be followed. Neither parent shall interfere with the school's decisions regarding event access, seating, or participation.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2">Vacation Weeks Per Year (each parent)</label>
                <select value={planData.vacationWeeks} onChange={function(e) { updateData('vacationWeeks', e.target.value); }}
                  className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2">
                  {['1', '2', '3', '4'].map(function(v) { return <option key={v} value={v}>{v} week(s)</option>; })}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Vacation Notice Period</label>
                <select value={planData.vacationNotice} onChange={function(e) { updateData('vacationNotice', e.target.value); }}
                  className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2">
                  <option value="30days">30 Days</option>
                  <option value="60days">60 Days</option>
                  <option value="90days">90 Days</option>
                </select>
              </div>
            </div>

            {/* Vacation During School Year */}
            <div className="card-surface p-5 space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">Is Vacation Allowed During the School Year?</label>
                <div className="grid grid-cols-2 gap-2">
                  {[
                    { id: 'allowed', label: 'Allowed' },
                    { id: 'disallowed', label: 'Not Allowed' },
                  ].map(function(opt) {
                    return (
                      <button key={opt.id} onClick={function() { updateData('vacationDuringSchool', opt.id); }}
                        className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                          (planData.vacationDuringSchool === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                        data-testid={'vacation-school-' + opt.id}>
                        {opt.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              {planData.vacationDuringSchool === 'allowed' && (
                <div>
                  <label className="block text-sm font-medium mb-2">When Is Vacation Permitted During the School Year?</label>
                  <div className="space-y-2">
                    {[
                      { id: 'breaks-only', label: 'Holiday Breaks Only', desc: 'Vacation is restricted to scheduled school breaks (winter break, spring break, long weekends)' },
                      { id: 'regular-days', label: 'Regular School Days Allowed', desc: 'Vacation may include regular school days (child will miss class)' },
                    ].map(function(opt) {
                      return (
                        <button key={opt.id} onClick={function() { updateData('vacationSchoolTiming', opt.id); }}
                          className={'w-full p-3 rounded-lg border text-left transition-all ' +
                            (planData.vacationSchoolTiming === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                          data-testid={'vacation-timing-' + opt.id}>
                          <p className="font-medium text-sm">{opt.label}</p>
                          <p className="text-xs text-white/50">{opt.desc}</p>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}

              {planData.vacationDuringSchool === 'allowed' && planData.vacationSchoolTiming === 'regular-days' && (
                <div>
                  <label className="block text-sm font-medium mb-2">Who Must Consent to Missing School Days?</label>
                  <p className="text-xs text-white/40 mb-3">When vacation causes the child to miss regular school days, whose approval is required?</p>
                  <div className="space-y-2">
                    {[
                      { id: 'both-consent', label: 'Both Parents Must Consent', desc: 'Both parents must agree before the child misses school for vacation' },
                      { id: 'legal-authority', label: 'Parent with Legal Authority for School Decisions', desc: 'Only the parent with legal custody over educational decisions may authorize missed school days' },
                      { id: 'traveling-parent', label: 'Traveling Parent Decides', desc: 'The parent taking the child on vacation may authorize the absence' },
                    ].map(function(opt) {
                      return (
                        <button key={opt.id} onClick={function() { updateData('vacationSchoolConsent', opt.id); }}
                          className={'w-full p-3 rounded-lg border text-left transition-all ' +
                            (planData.vacationSchoolConsent === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                          data-testid={'vacation-consent-' + opt.id}>
                          <p className="font-medium text-sm">{opt.label}</p>
                          <p className="text-xs text-white/50">{opt.desc}</p>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}

              {planData.vacationDuringSchool === 'disallowed' && (
                <div className="bg-white/[0.03] border border-white/[0.08] rounded-lg p-4">
                  <p className="text-xs text-white/60 leading-relaxed">
                    Vacation travel shall not be scheduled during the regular school year. All vacation time must occur during summer break or scheduled school holidays.
                  </p>
                </div>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Summer Schedule</label>
              <div className="space-y-2">
                {[
                  { id: 'same', name: 'Same as School Year', desc: 'Regular schedule continues through summer' },
                  { id: 'alternate-weeks', name: 'Alternating Weeks', desc: 'Parents alternate week-on/week-off during summer' },
                  { id: 'extended', name: 'Extended Time Blocks', desc: 'Each parent gets extended consecutive blocks' },
                  { id: 'custom', name: 'Custom Summer Schedule', desc: 'Separately agreed upon each year' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('summerSchedule', opt.id); }}
                      className={planData.summerSchedule === opt.id
                        ? 'w-full p-3 rounded-lg border text-left border-[#2D2560] bg-[#2D2560]/10'
                        : 'w-full p-3 rounded-lg border text-left border-white/10 hover:border-white/20'}>
                      <p className="font-medium text-sm">{opt.name}</p>
                      <p className="text-xs text-white/50">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Child's Birthday</label>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'alternate', label: 'Alternate Years' },
                  { id: 'shared', label: 'Shared / Joint Party' },
                  { id: 'separate', label: 'Separate Celebrations' },
                  { id: 'custodial', label: 'With Custodial Parent' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('birthdayRule', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.birthdayRule === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        
  );
};
